<template>
    <div>
        <a href="/coupon/coupon-list" v-if="allow_coupon">
            <temaplate slot="title">
                <div class="media align-items-center custom-media-nav-size" slot="title">
                    <i class="fa fa-ticket-alt text-color-wallet" style="transform: rotate(-45deg);"></i>
                    <div :class="['media-body ml-2 d-none d-md-block d-lg-block pr-1', { 'text-color-wallet': !load_coupon_balances }]">
                        <span v-bind:style="{color: this.$THEME.primaryColor}" :class="(this.$THEME.primaryColor?'':'text-blue')" v-if="load_coupon_balances">
                            <i class="fas fa-circle-notch fa-spin"></i>
                        </span>
                        <div class="text-right font-weight-bold pb-0" v-else>
                            <span class="text-sm">{{$COUPON.balance_amount}}</span>
                            <p class="mb-0 pb-0 small text-right">คูปอง (ใบ)</p>
                        </div>
                    </div>
                </div>
            </temaplate>
        </a>
    </div>
</template>

<script>
    import { fetchCouponBalanceToLocalStorage } from '@/axios/coupon.js'

    export default {
        name: "DropDownCoupon",
        data() {
            return {
                load_coupon_balances: true,
                allow_coupon: false,
            }
        },
        created() {
            if (this.main_use_walletV2 && this.main_allow_coupon && [
                    this.$USER_LOGIN.get().isAdmin,
                    this.$USER_LOGIN.get().isMember
                ].includes(true)) {
                this.allow_coupon = true
            }
        },
        mounted() {
            fetchCouponBalanceToLocalStorage().then((res) => {
                this.$COUPON.status = res.status
                this.$COUPON.balance_amount = res.balance_amount
                this.$COUPON.total_amount = res.total_amount
                this.$COUPON.balance_value = res.balance_value
                this.$COUPON.total_value = res.total_value
            })
            .catch()
            .finally(() => {
                this.load_coupon_balances = false
            })
        }
    }
</script>